import { React, PT } from '@gasbuddy/react';
import { Button, Form, Message, Loader, Dimmer } from 'semantic-ui-react';
import { LoginStatus } from './AuthConstants';

export const LoginForm = class LoginForm extends React.Component {
  state = {
    email: '',
    password: '',
    otp: '',
  }

  onChangeFunctor(fieldName) {
    return (event) => {
      this.setState({ [fieldName]: event.target.value });
    };
  }

  doLogin = (event) => {
    event.preventDefault();
    const { email, password, otp } = this.state;
    const { beginAuthentication } = this.props;
    beginAuthentication({ email, password, otp });
  }

  render() {
    const { status } = this.props;
    const { password, email, otp } = this.state;
    return (
      <Form error={status === LoginStatus.Failed} method="POST">
        <Dimmer active={status === LoginStatus.InProgress}>
          <Loader />
        </Dimmer>
        <Message
          error
          header="Invalid Login"
          content="The credentials entered did not match an existing account."
        />
        <Form.Field>
          <Form.Input
            label="Your Email Address"
            placeholder="someone@gasbuddy.com"
            autoComplete="email"
            name="email"
            onChange={this.onChangeFunctor('email')}
            value={email}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            autoComplete="current-password"
            label="Password"
            type="password"
            placeholder="******"
            name="password"
            ref={(input) => { this.passwordInput = input; }}
            onChange={this.onChangeFunctor('password')}
            value={password}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            autoComplete="one-time-code"
            inputMode="numeric"
            pattern="[0-9]*"
            label="Token"
            placeholder="000000"
            name="token"
            onChange={this.onChangeFunctor('otp')}
            value={otp}
          />
        </Form.Field>
        <Button onClick={this.doLogin}>Submit</Button>
      </Form>
    );
  }
};

LoginForm.propTypes = {
  beginAuthentication: PT.func.isRequired,
  status: PT.number,
};

LoginForm.defaultProps = {
  status: LoginStatus.LoggedOut,
};
